endurmenntun = (typeof endurmenntun != 'undefined') ? endurmenntun : {};

//noinspection JSUnusedGlobalSymbols
endurmenntun.course = {
	initEdit: function() {
		endurmenntun.course.dates.init();
		endurmenntun.course.units.init();
		endurmenntun.course.period.init();
		endurmenntun.course.dates.postInit();
		endurmenntun.course.units.postInit();
		endurmenntun.course.period.postInit();
		endurmenntun.course.access.init();
	},
	isAdmin: function() {
		return $('body').hasClass('emAdmin');
	},
	access: {
		init: function() {
			$('.eType_multiselect select').multiselect({
				sortable: false,
				searchable: false
			});
			$('#endurmenntun').find('#access').change(function(){
				var $this = $(this);
				var v = $this.val();
				if (v == 2) { // private
					$('#elm_assignees').show();
					$('#elm_workplaceId').hide();
				}
				else if (v == 1) { //public
					$('#elm_assignees').hide();
					$('#elm_workplaceId').hide();
				}
				else { //company
					$('#elm_workplaceId').show();
					$('#elm_assignees').hide();
				}
			}).trigger('change');
		}
	},
	period: {
		init: function () {
			$('#categoryId').change(function () {
				var $select = $(this);
				console.log($select.val());
				// todo: fix hardcoding
				if ($select.val() === '7') {
					endurmenntun.course.dates.reset();
					endurmenntun.course.period.reset();
					$('#fieldset-dates').hide();
					$('#fieldset-period').show();
				}
				else {
					endurmenntun.course.dates.reset();
					endurmenntun.course.period.reset();
					$('#fieldset-dates').show();
					$('#fieldset-period').hide();
				}
			});

			$('#periodHours').on('keyup', function () {
				var value = parseInt($(this).val().replace ( /[^\d.]/g, '' ));
				endurmenntun.course.period.updateUnits(value);
			});
		},
		postInit: function () {
			if ($('#categoryId').val() === '7') {
				$('#fieldset-dates').hide();
				$('#fieldset-period').show();
				$('#periodHours').trigger('keyup');
			}
		},
		updateUnits: function (hours) {
			// todo: remove hardcoded value
			var units = hours * 4;
			$('#periodUnits').val(units);
			console.log(units * 10);
			endurmenntun.course.units.getPre().timepicker('setTotal', units * 60);
			endurmenntun.course.units.check();
		},
		reset: function () {
			$('#fieldset-period .text').val('');
			endurmenntun.course.units.getPre().timepicker('setTotal', 0);
			endurmenntun.course.units.check();
		}
	},
	dates: {
		init: function () {
			endurmenntun.course.dates.getMainWrap().after(endurmenntun.course.dates.getAddLink());
		},
		postInit: function() {
			if (!endurmenntun.course.dates.addInitial()) {
				endurmenntun.course.dates.add();
			}
		},
		addInitial: function() {
			var ret = false;
			endurmenntun.course.dates.getFieldset().find('.initDate').each(function(){
				var j = $.parseJSON(this.value);
				if (j) {
					endurmenntun.course.dates.add(j);
					ret = true;
					$(this).remove();
				}
			});
			if (ret) {
				endurmenntun.course.dates.update();
			}
			return ret;
		},
		getAddLink: function () {
			return endurmenntun.icon('create', 'datesAdd').click(endurmenntun.course.dates.eAdd);
		},
		eAdd: function (e) {
			e.preventDefault();
			endurmenntun.course.dates.add();
			return false;
		},
		add: function (options) {
			var $ul = endurmenntun.course.dates.getMainWrap();
			var $el = endurmenntun.course.dates.createRow(options);
			$ul.append($el);
		},
		fs : null,
		getFieldset: function() {
			if (!endurmenntun.course.dates.fs) {
				endurmenntun.course.dates.fs = $('#fieldset-dates');
			}
			return endurmenntun.course.dates.fs;
		},
		dw : null,
		getMainWrap: function() {
			if (!endurmenntun.course.dates.dw) {
				endurmenntun.course.dates.dw = $('#dateWrap').find('tbody');
			}
			return endurmenntun.course.dates.dw;
		},
		createRow: function(options) {
			var $html = $('<tr></tr>');
			var $inputDate = $('<input type="text" name="dates[date][]" class="datepicker date" value="" />');
			var $inputFrom = $('<input type="text" name="dates[from][]" class="timepicker from" value="" />');
			var $inputTo = $('<input type="text" name="dates[to][]" class="timepicker to" value="" />');
			var $aClose = endurmenntun.icon('close', 'datesRemove');

			$html.append($inputDate)
				.append($inputFrom)
				.append($inputTo)
				.append($aClose);

			if (options && options.date) {
				$inputDate.val(options.date);
			}
			if (options && options.from) {
				$inputFrom.val(options.from);
			}
			if (options && options.to) {
				$inputTo.val(options.to);
			}

			$inputDate.wrap('<td class="date"/>').datepicker({dateFormat:"dd.mm.yy"});
			$inputFrom.wrap('<td class="from"/>').timepicker();
			$inputTo.wrap('<td class="to"/>').timepicker();
			$aClose.wrap('<td class="close"/>').data('row', $html).click(endurmenntun.course.dates.removeRow);
			$html.find('.timepicker').change(endurmenntun.course.dates.update);
			return $html;
		},
		update: function() {
			var total = 0;
			endurmenntun.course.dates.getMainWrap().find('tr').each(function(){
				var $this = $(this);
				var date = $this.find('input.date').val();
				var from = $this.find('input.from').timepicker('getTotal');
				var to = $this.find('input.to').timepicker('getTotal');
				if (date && from && to && (from < to)) {
					total += (to-from);
				}
			});
			endurmenntun.course.units.getPre().timepicker('setTotal', total);
			endurmenntun.course.units.check();
		},
		reset: function () {
			var total = 0;
			endurmenntun.course.dates.getMainWrap().find('tr').each(function(){
				var $this = $(this);
				$this.find('input.date').val('');
				$this.find('input.from').timepicker('reset');
				$this.find('input.to').timepicker('reset');
			});
			endurmenntun.course.units.getPre().timepicker('setTotal', total);
			endurmenntun.course.units.check();
		},
		removeRow: function() {
			$(this).data('row').remove();
			return false;
		}
	},
	units: {
		init: function() {
			endurmenntun.course.units.getPost().parent().append('<span id="unitStatus" class="none" />');
			endurmenntun.course.units.getFieldset().find('input.timepicker').timepicker({
				hoursMax: 120,
				hoursPad: false,
				hoursStart:0
			});
			endurmenntun.course.units.getFieldset().find('input.timepicker').change(function(){
				if (!this.disabled) {
					endurmenntun.course.units.update();
				}
			});
		},
		postInit: function() {

		},
		fs: null,
		getFieldset: function() {
			if (!endurmenntun.course.units.fs) {
				endurmenntun.course.units.fs = $('#fieldset-units');
			}
			return endurmenntun.course.units.fs;
		},
		getPre: function() {
			return endurmenntun.course.units.getFieldset().find('#units-unitpre');
		},
		getPost: function() {
			return endurmenntun.course.units.getFieldset().find('#units-unitpost');
		},
		getStatusSpan: function() {
			return endurmenntun.course.units.getFieldset().find('#unitStatus');
		},
		update: function() {
			endurmenntun.course.units.doUpdate();
			endurmenntun.course.units.check();
		},
		doUpdate: function() {
			var total = 0;
			endurmenntun.course.units.getFieldset().find('input.timepicker').each(function() {
				if (!this.disabled) {
					if (this.value) {
						total += $(this).timepicker('getTotal');
					}
				}
			});
			endurmenntun.course.units.getPost().timepicker('setTotal', total);
			return total;
		},
		check: function() {
			console.log('check');
			var postTotal = endurmenntun.course.units.getPost().timepicker('getTotal');
			if (postTotal < 1) {
				postTotal = endurmenntun.course.units.doUpdate();
			}
			var preTotal = endurmenntun.course.units.getPre().timepicker('getTotal');
			var s = 'none';
			if (preTotal < 1) {

			}
			else if (preTotal < postTotal) {
				s = 'big';
			}
			else if (preTotal > postTotal) {
				s = 'small';
			}
			else {
				s = 'ok';
			}
			var statusSpan = endurmenntun.course.units.getStatusSpan();
			statusSpan.attr('class', s);
			statusSpan.text(endurmenntun.translations._('unitStatus_'+s));
			// make sure always ok to save
			var submit = $('#elm_controls').find('#submitForm');
			if (s == 'ok' || endurmenntun.course.isAdmin()) {
				submit.removeAttr('disabled');
			} else {
				submit.attr('disabled', 'disabled');
			}
		}
	}
};
endurmenntun.icon = function(c, tKey) {
	var t = endurmenntun.translations._(tKey);
	return $('<a href="#" class="icon ' + c + '" title="' + t + '"><i></i><span>'
		+ t
		+'</span></a>');
};

endurmenntun.translations = {
	data : {},
	setData: function (data) {
		if (data) {
			if (data.ui && $.ui.multiselect) {
				$.ui.multiselect.locale = data.ui;
				data.ui = null;
			}
			endurmenntun.translations.data = data;
		}
	},
	_: function(key) {
		if (endurmenntun.translations.data.hasOwnProperty(key)) {
			return endurmenntun.translations.data[key];
		}
		return key;
	}
};
endurmenntun.courseCalendar = {};
endurmenntun.courseCalendar.init = function (calOpts) {

	function checkLoading(isLoading, view) {
		if (isLoading) {
			$('#event_static').hide();
			$('#event_loading').show();
		}
		else {
			$('#event_static').show();
			$('#event_loading').hide();
		}
	}

	var numberOfViews = 0;
	var embCalFilter = calOpts.currentFilter;

	var $cal = $('#calendar');
	$cal.fullCalendar({
		editable: false,
		events: function (start, end, callback) {
			$.ajax({
				url: calOpts.url,
				type: 'GET',
				dataType: 'json',
				data: {
					f: embCalFilter,
					// our hypothetical feed requires UNIX timestamps
					start: Math.round(start.getTime() / 1000),
					end: Math.round(end.getTime() / 1000)
				},
				success: function (doc) {
					callback(doc);
					var x = $('#calendar').find('.fc-widget-content');
					x.hover(
						function () {
							$(this).addClass('hover');
						},
						function () {
							$(this).removeClass('hover');
						}
					);
				}
			});
		},
		loading: checkLoading,
		monthNames: calOpts.monthNames,
		monthNamesShort: calOpts.monthNamesShort,
		dayNames: calOpts.dayNames,
		dayNamesShort: calOpts.dayNamesShort,
		timeFormat: 'H(:mm) { - H(:mm)}', // uppercase H for 24-hour clock
		buttonText: {
			today: calOpts.buttonTextToday,
			month: calOpts.buttonTextMonth,
			week: calOpts.buttonTextWeek,
			day: calOpts.buttonTextDay
		},
		year: calOpts.year,
		month: calOpts.currentMonth,
		eventRender: function (event, element) {
			if (event.description) {
				/*element.attr('title', event.description);*/
			}
			if (event.access) {
				element.addClass('access-' + event.access);
			}
			if (event.reg && event.reg > 0) {
				element.find('.fc-event-inner').prepend('<span class="registered"></span>');
			}
		},
		eventClick: function (calEvent, jsEvent, view) {
			var $d = $('#eventDialog');
			if (calEvent.access == "transfer") return false;
			$d.dialog('option', 'title', calEvent.title);
			$d.data('eventId', calEvent.id);
			$d.find('.content').html('');
			$d.find('.loading').removeClass('hide');
			$d.dialog('open');
		},
		viewDisplay: function (view) {
			var $months = $('#months');
			var mon = view.start.getMonth();
			var year = view.start.getFullYear();
			$('#year').val(year);
			$months.find('li').each(function () {
				var $this = $(this);
				$this.removeClass('selected');
				if ($this.attr('rel') == mon) {
					$this.addClass('selected');
				}
			});
			document.title = view.title + ' - ' + document.title.replace(/^[^ ]+ [0-9]+ - /, '');
			if (history && history.pushState) {
				var url = null;
				if (numberOfViews++ > 0) {
					url = window.location.href.replace(/\?.*/, '');
					var s = view.start.getTime() / 1000;
					var e = view.end.getTime() / 1000;
					url = url + "?start=" + s + "&end=" + e + '&f=' + embCalFilter;
				}
				history.pushState(null, null, url)
			}
		},
		eventAfterRender: function (event, $element, view) {
			var d = event.start;
			var c = 'fcx-' + getSimpleDate(d);
			var $td = $('.' + c);
			$td.addClass('fcx-hasEvent');
			var $w = $td.find('.fc-day-content');
			if ($w.length == 1) {
				$element.appendTo($w);
				$element.css('position', 'inherit');
			}
			else {
				// This is bad!
			}
		}
	});

	$('#eventDialog').dialog({
		autoOpen: false,
		height: 500,
		dialogClass: 'calEvent',
		width: 600,
		open: function () {
			var $this = $(this);
			var eventId = $this.data('eventId');
			$this.find('.content').load(calOpts.urlView + '/' + eventId, function () {
				$('#eventDialog').find('.loading').addClass('hide');
			});
		}
	});
	$('#months li').click(function () {
		var $cal = $('#calendar');
		var date = $cal.fullCalendar('getDate');
		var year = date.getFullYear();
		var rel = $(this).attr('rel');
		if (rel) {
			var newMonth = parseInt(rel);
			$cal.fullCalendar('gotoDate', year, newMonth);
		}
		return false;
	});
	$('#calFilter li').click(function () {
		var $this = $(this);
		var $cal = $('#calendar');
		embCalFilter = parseInt($this.attr('rel'));
		$cal.fullCalendar('refetchEvents');
		$this.parent().find('li').removeClass('selected');
		$this.addClass('selected');
		return false;
	});
	$('#year').change(function () {
		var $cal = $('#calendar');
		var date = $cal.fullCalendar('getDate');
		$cal.fullCalendar('gotoDate', $(this).val(), date.getMonth());
	});
};

endurmenntun.workplaces = function() {
	var $form = $('#wpForm');

	$.ui.multiselect.locale = {
		addAll: $form.data('addall'),
		removeAll: $form.data('removeall'),
		itemsCount: $form.data('itemscount')
	};
	var $workplaces = $('.eType_multiselect select');
	var $main = $('#mainWorkplaceId');

	$workplaces.multiselect({
		sortable: false,
		searchable: false
	});

	$workplaces.change(function(){
		var $t = $(this);
		var newList = $t.val();
		$main.find('option').each(function(){
			var v = this.value;
			if (v != '') {
				var ni = newList.indexOf(v);
				if (ni < 0) {
					$(this).remove();
				}
				else {
					newList.splice(ni,1);
				}
			}
		});
		for (var i= 0,c=newList.length;i<c;i++) {
			var t = newList[i];
			$main.append($('<option>', {value: t}).text($t.find('option[value='+t+']').text()));
		}
	});
};

endurmenntun.videos = function() {
	const $overview = $('#video__overview');
	$('.filter button', $overview).on('click', function() {
		let $this = $(this);
		$this
			.addClass('selected')
			.siblings().removeClass('selected');
		$overview.removeAttr('class').addClass($this.attr('data-value'));
	});
};

(function($) {
	var methods = {
		init: function(options) {
			var settings = $.extend(this.timepicker('getSettings'), options);

			this.wrap('<div class="tpWrap"/>');
			this.css('display', 'none');

			return this.each(function() {
				var $this = $(this);

				var id = Math.floor((Math.random()*10000000)+1);
				$this.data('tpId', id);
				$this.addClass('x'+id);

				var $time1 = $('<select class="tpSel time1" id="tp_t1_'+id+'" />');
				var $time2 = $('<select class="tpSel time2" id="tp_t2_'+id+'" />');
				$time1.timepicker('timeSelect',
					settings.hoursStart,
					settings.hoursInc,
					settings.hoursMax,
					settings.hoursPad
				);
				$time2.timepicker('timeSelect',
					settings.minStart,
					settings.minInc,
					settings.minMax,
					settings.minPad
				);

				// backwards to get the order right :)
				$this.after($time2).after($time1);

				var $elements = $this.parent().find('select.tpSel');
				$elements.data('tpId', id);
				$elements.change(function() {
					$this.timepicker('getMain').timepicker('update');
				});
				var d = $this.attr('disabled');
				if (d) {
					$elements.attr('disabled', 'disabled');
				}
				if (!this.value) {
					this.value = settings.hoursStart + ':' + settings.minStart.toString().lpad('0', 2);
				}
				var x = this.value.split(':');
				if (x.length == 1) {
					var h = Math.ceil(x[0]/60);
					var m = x[0]-(h*60);
					x = [h,m];
					this.value = h+':'+m;
				}
				else if (x.length == 2) {
					x[0] = x[0].replace(' ', '');
					x[1] = x[1].replace(' ', '');
				}
				$time1.val(x[0]);
				$time2.val(x[1]);
			});
		},
		getSettings: function () {
			return {
				hoursStart: 7,
				hoursMax: 24,
				hoursInc: 1,
				hoursPad: false,
				minStart: 0,
				minMax: 60,
				minInc: 30,
				minPad: true
			}
		},
		setTotal: function(value) {
			var hours = Math.floor(value/60);
			var minutes = value-(hours*60);
			minutes = minutes.toString().lpad('0', 2);
			this.timepicker('getSelect', 1).val(hours);
			this.timepicker('getSelect', 2).val(minutes);
			this.timepicker('update');
		},
		getMain: function() {
			return $('.x' + $(this).data('tpId'));
		},
		timeSelect: function (start, inc, max, doPadding) {
			var t;
			var ret = '';
			var l = String(max).length;
			for (var i = start; i < max; i+=inc) {
				t = i.toString();
				if (doPadding) {
					t = t.lpad('0', l);
				}
				ret += '<option value="'+t+'">'+t+'</option>';
			}
			this.append(ret);
			return this;
		},
		getSelect: function(num) {
			var s = '#tp_t'+num+'_' + this.data('tpId');
			return $(s);
		},
		getTotal: function() {
			var total = 0;
			this.each(function() {
				var v = this.value;
				if (v) {
					var x = v.split(':');
					total += ((parseInt(x[0])*60) + (parseInt(x[1])));
				}
			});
			return total;
		},
		update: function() {
			var $time1 = this.timepicker('getSelect', 1);
			var $time2 = this.timepicker('getSelect', 2);
			var v = $time1.val() + ':' + $time2.val();
			this.attr('value', v);
			this.trigger('change');
			return this;
		},
		reset: function () {
			console.log('reset timepicker')
			var settings = this.timepicker('getSettings');
			this.timepicker('getSelect', 1).val(settings.hoursStart);
			this.timepicker('getSelect', 2).val('00');
		}
	};
	$.fn.timepicker = function( method ) {
		if (!String.prototype.hasOwnProperty('lpad')) {
			String.prototype.lpad = function(padString, length) {
				var str = this;
				while (str.length < length)
					str = padString + str;
				return str+"";
			}
		}
		// Method calling logic
		if ( methods[method] ) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === 'object' || ! method) {
			return methods.init.apply(this, arguments);
		} else {
			return $.error('Method ' +  method + ' does not exist on jQuery.timepicker');
		}
	};
})(jQuery);

endurmenntun.report = (function($) {
	var $grid, $box, $filterButtons, $newFilter, selectedYear;
	function init(id, year) {
		selectedYear = year;
		$grid = $('#grid-' + id);
		if ($grid.length !== 1) {
			return;
		}
		$box = $grid.parents('.box');
		$filterButtons = $grid.find('.filter-buttons');
		$newFilter = $box.find('#newFilter');
		initFilterReset();
		initFilter();
		initMerges();
		initYearLinks();
	}
	function initFilter() {
		$newFilter.prependTo($filterButtons);
	}

	function initMerges() {
		var $totalGroups = $grid.find('.totalGroup');
		if ($totalGroups.length > 0) {
			initMergeGroups($totalGroups);
		} else {
			initMergeSimple();
		}
	}
	function initMergeSimple() {
		var $totalLine = $grid.find('tr.total');
		var totalColumns = 1;
		var $first;
		$totalLine.find('td.merge').each(function() {
			var $t = $(this);
			if (!$first) {
				$first = $t.prev();
			}
			$t.remove();
			totalColumns++;
		});
		if ($first) {
			$first.attr('colspan', totalColumns);
		}
	}
	function initMergeGroups($totalGroups) {
		$totalGroups.each(function(){
			var t = $(this);
			var $first;
			var totalColumns = 1;
			t.find('td.totalMerge').each(function() {
				var t2 = $(this);
				if (null == $first) {
					$first = t2.prev();
				}
				t2.remove();
				totalColumns++;
			});
			if ($first) {
				$first.attr('colspan', totalColumns);
			}
		});
	}
	function initFilterReset() {
		$filterButtons.find('button').hide();
	}
	function initYearLinks() {
		var $paginator = $grid.find('.paginator');
		if ($paginator.length < 1) {
			return;
		}
		$paginator.find('a').each(function(){
			var href = this.href;
			if (href.match('page')) {
				this.href += '&year=' + selectedYear;
			}
		});
		var $input = $('<input type="hidden" name="year" />');
		$input.val(selectedYear);
		$paginator.find('form').prepend($input);
		var currentPage = parseInt($paginator.find('#paginator-page').val());
		var $pageInput = $('<input type="hidden" name="page" />');
		$pageInput.val(currentPage);
		$grid.find('form').prepend($pageInput);
	}
	return {
		init: init
	}
})(jQuery);
